export enum FundStatus {
  PENDING = 'PENDING',
  SUBMITTED = 'SUBMITTED',
  SETTLED = 'SETTLED',
  RETURNED = 'RETURNED',
  VOIDED = 'VOIDED',
  DECLINED = 'DECLINED',
}
